// extracted by mini-css-extract-plugin
module.exports = {"container":"ConditionLabel_container__2-3l2","icon":"ConditionLabel_icon__nIYkn","passed":"ConditionLabel_passed__1jQpz","text":"ConditionLabel_text__2bqk5"};